import { render, staticRenderFns } from "./evrak_modal.vue?vue&type=template&id=6c5ee726&scoped=true"
import script from "./evrak_modal.vue?vue&type=script&lang=js"
export * from "./evrak_modal.vue?vue&type=script&lang=js"
import style0 from "./evrak_modal.vue?vue&type=style&index=0&id=6c5ee726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ee726",
  null
  
)

export default component.exports